export default [
  {
    name: 'alterar-senha-externo',
    path: '/portal-cliente/alterar-senha-externo',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/app-modulo/documento/alterar-senha-externo/AlterarSenhaExterno.vue'),
    meta: {
      resource: 'alterarsenhaexterno',
      action: 'auditar',
      requiredAuth: false,
      layout: 'full',
    },
  },
]
